import { Type } from "class-transformer";

export class Fax
{
    id: any;
    attn : string;
    from: string;
    subject: string;
    notes: string
    faxNumber: string;
    status: string;
    totalPages: number
    pagesSent: number;
    retries: number;

    constructor
    (
        id: number,
        attn : string,
        from: string,
        subject: string,
        notes: string,
        faxNumber: string,
        status: string,
        totalPages: number,
        pagesSent: number,
        retries: 1
    )
    {
        this.id = id;
        this.attn = attn;
        this.from = from;
        this.subject = subject;
        this.notes = notes;
        this.faxNumber = faxNumber;
        this.status = status;
        this.totalPages = totalPages;
        this.pagesSent = pagesSent;
        this.retries = retries;     
    }

    @Type(() => Date)
    faxSendTime?: Date;

    @Type(() => Date)
    faxCompleteTime?: Date;

    attachmentIds: string[] = [];
}

export class FaxWrite
{
    attn: string;
    from: string;
    subject: string;
    notes: string;
    faxNumber: string;

    constructor
    (
        attn: string,
        from: string,
        subject: string,
        notes:string,
        faxNumber:string
    )
    {
        this.attn = attn;
        this.from = from;
        this.subject = subject;
        this.notes = notes;
        this.faxNumber = faxNumber;
    }
    attachmentIds: string[] = [];
}
